import { nprogress } from "@mantine/nprogress";

// Uçuştaki YAZMA isteklerinin sayacı. Kaynak axios interceptor'ları (lib/axios) — react-query'nin
// useIsFetching sayaçları yerine burayı kullanıyoruz, çünkü /auth/refresh gibi react-query dışındaki
// çağrılar da API'ye gidiyor ve göstergeye dahil olmalı.
//
// GET'ler bilerek dışarıda (bkz. lib/axios): sayfa geçişleri hep GET ve her geçişte çubuğun yanıp
// sönmesi istenmiyordu.
let inFlight = 0;

// Çok hızlı isteklerde çubuk bir kare görünüp kaybolurdu; göz bunu titreme olarak algılıyor.
// Bu eşiğin altında biten istekler hiç göstermiyor.
const SHOW_AFTER_MS = 150;
let showTimer = null;

export const startRequest = () => {
  inFlight += 1;

  // inFlight 1 olduğunda önceki değer 0'dı ve endRequest sıfıra inerken zamanlayıcıyı hep
  // temizliyor, yani showTimer zorunlu olarak null.
  if (inFlight === 1) {
    showTimer = setTimeout(() => {
      showTimer = null;

      // Zamanlayıcı dolduğunda hâlâ bekleyen istek varsa göster.
      if (inFlight > 0) {
        nprogress.start();
      }
    }, SHOW_AFTER_MS);
  }
};

export const endRequest = () => {
  // Negatife düşmesin: bir isteğin iki kez bitmesi (iptal + hata) sayacı bozar ve çubuk
  // bir daha hiç görünmezdi.
  inFlight = Math.max(0, inFlight - 1);

  if (inFlight > 0) {
    return;
  }

  if (showTimer !== null) {
    clearTimeout(showTimer);
    showTimer = null;

    return;
  }

  nprogress.complete();
};
